/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {PaymentCardSkeleton} from "./PaymentCardSkeleton";

export const PaymentSkeleton = () => (
    <div className="p-selector--payment p-margin-bottom-none">
        {[...Array(2)].map((item, i) => <PaymentCardSkeleton key={i}/>)}
    </div>
)
